import React from "react";

interface IDVerificationDeniedProps {
  onResubmit: () => void;
}

const IDVerificationDenied = ({ onResubmit }: IDVerificationDeniedProps) => {
  return (
    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "80vh" }}>
      <div
        style={{
          width: "100%",
          maxWidth: "550px",
          padding: "2rem 2.5rem",
          borderRadius: "5px",
          boxShadow: "0 0 20px rgba(0, 0, 0, 0.15)",
          backgroundColor: "#fff",
          textAlign: "center",
          fontFamily: "inherit",
        }}
      >
        <div
          style={{
            width: "80px",
            height: "80px",
            borderRadius: "50%",
            border: "4px solid #dc3741",
            margin: "0 auto 1.25rem",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#dc3741" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10" />
            <line x1="15" y1="9" x2="9" y2="15" />
            <line x1="9" y1="9" x2="15" y2="15" />
          </svg>
        </div>

        <h2 style={{ fontSize: "1.35rem", fontWeight: 600, marginBottom: "0.75rem", color: "#595959" }}>
          ID Verification Denied
        </h2>
        <p style={{ fontSize: "0.95rem", color: "#545454", lineHeight: 1.6, marginBottom: "1.5rem" }}>
          Your school ID verification was denied. Please resubmit an image of your school ID.
        </p>
        <button
          onClick={onResubmit}
          style={{
            padding: "0.6rem 2rem",
            fontSize: "0.95rem",
            fontWeight: 600,
            color: "#fff",
            backgroundColor: "#21212E",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
          }}
        >
          Upload New ID
        </button>
      </div>
    </div>
  );
};

export default IDVerificationDenied;
